import React from "react";
import "./whoWeAre.css";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { FiGlobe } from "react-icons/fi";
import { IoIosPeople } from "react-icons/io";
import { TbChecklist } from "react-icons/tb";
import { BsGraphUp } from "react-icons/bs";
import { GiBullseye } from "react-icons/gi";
import { RiTeamFill } from "react-icons/ri";
import { AiOutlineStock } from "react-icons/ai";
import { SiSonarsource } from "react-icons/si";
import { FaHandsHelping } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { VscSymbolStructure } from "react-icons/vsc";
import { MdWebAsset } from "react-icons/md";
import { FaAssistiveListeningSystems } from "react-icons/fa";
import work from "../../Assets/work2.jpg";
import KnowHow from "../KnowHow/KnowHow";
const WhoWeAre = (props) => {
  const t = props.language;
  const { ref: descriptionRef, inView: descriptionRefIsVisible } = useInView();
  const { ref: whoweareRef, inView: whoweareIsvisible } = useInView();
  const [years, setYears] = useState(0);

  // let interval;
  useEffect(() => {
    let interval;
    if (descriptionRefIsVisible === true && years < 40) {
      interval = setInterval(() => {
        setYears((years) => years + 1);
      }, 100);
      return () => clearInterval(interval);
    } else if (years >= 40) {
      clearInterval(interval);
    }
  }, [descriptionRefIsVisible, years]);

  return (
    <section className="who-we-are" id="who-we-are">
      <div className="holder">
        <h1 className="text__title">{t("who_we_are")}</h1>
        <span className={"line__isVisible"}></span>
      </div>
      <div ref={whoweareRef} className="who-we-are__container"></div>
      <div className="who-we-are__container">
        <span className="company">{t("who_we_are__text")}</span>
      </div>
      <div className="about__us--container">
        <div className="about__us--body">
          <div className="about__us--body--element">
            <div className="about__us--body--left">
              <h3>{t("network")}</h3>
              <span>{t("network_text")}</span>
            </div>
            <div className="about__us--icons--wrap">
              <FiGlobe className="about__us--icons" />
            </div>
          </div>
          <div className="about__us--body--element">
            <div className="about__us--icons--wrap">
              <IoIosPeople className="about__us--icons" />
            </div>
            <div className="about__us--body--left">
              <h3>{t("experienced_senior")}</h3>
              <span>{t("experienced_senior_text")}</span>
            </div>
          </div>
        </div>
        <div className="about__us--body">
          <div className="about__us--body--element">
            <div className="about__us--body--left">
              <h3>{t("regularity")}</h3>
              <span>{t("regularity_text")}</span>
            </div>
            <div className="about__us--icons--wrap">
              <TbChecklist className="about__us--icons" />
            </div>
          </div>
          <div className="about__us--body--element">
            <div className="about__us--icons--wrap">
              <BsGraphUp className="about__us--icons" />
            </div>
            <div className="about__us--body--left">
              <h3>{t("track")}</h3>
              <span>{t("track_text")}</span>
            </div>
          </div>
        </div>
        <div className="about__us--body">
          <div className="about__us--body--element">
            <div className="about__us--body--left">
              <h3>{t("independence")}</h3>
              <span>{t("independence_text")}</span>
            </div>
            <div className="about__us--icons--wrap">
              <RiTeamFill className="about__us--icons" />
            </div>
          </div>
          <div className="about__us--body--element">
            <div className="about__us--icons--wrap">
              <GiBullseye className="about__us--icons" />
            </div>
            <div className="about__us--body--left">
              <h3>{t("amc")}</h3>
              <span>{t("amc_text")}</span>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="idk-side">
          <div className="left-idk-side">
            <img src={work} alt="" className="img-work" />
          </div>
          <div className="right-side">
            <div className="row-main">
              <div>
                <span className="number-test">1</span>
              </div>
              <div className="column-main">
                
                <h4>{t("kh_1")}</h4>
              </div>
            </div>
            <div className="row-main">
              <div>
                <span className="number-test">2</span>
              </div>
              <div className="column-main">
                
                <h4>{t("kh_5")}</h4>
              </div>
            </div>

            <div className="row-main">
              <div>
                <span className="number-test">3</span>
              </div>
              <div className="column-main">
                
                <h4>{t("kh_2")}</h4>
              </div>
            </div>
            <div className="row-main">
              <div>
                <span className="number-test">4</span>
              </div>
              <div className="column-main">
               
                <h4>{t("kh_6")}</h4>
              </div>
            </div>

            <div className="row-main">
              <div>
                <span className="number-test">5</span>
              </div>
              <div className="column-main">
               
                <h4>{t("kh_3")}</h4>
              </div>
            </div>
            <div className="row-main">
              <div>
                <span className="number-test">6</span>
              </div>
              <div className="column-main">
               
                <h4>{t("kh_7")}</h4>
              </div>
            </div>
            <div className="row-main">
              <div>
                <span className="number-test">7</span>
              </div>
              <div className="column-main">
                
                <h4>{t("kh_4")}</h4>
              </div>
            </div>
          </div>
        </div> */}
      {/* <div className="description" ref={descriptionRef}>
        <span className="years">
          {descriptionRefIsVisible ? years + "+" : "0+"}
        </span>
        <span>{t("years_of_experience")}</span>
        <p>{t("who_we_are_p1")}</p>
        <p>{t("who_we_are_p2")}</p>
      </div> */}
    </section>
  );
};

export default WhoWeAre;
